export const DataLayerMain = (event, data) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: event,
        ecommerce: data
    });
    return true
}


export const visitProductDataLayer = (product) => {
    DataLayerMain(
        'select_item', 
        {
            items: [{
                item_name: product.G_NAME,
                item_id: product.G_CODE,
                item_brand: product.G_BR_NAME,
                item_category: product.G_GR_NAME,
                item_category2: product.G_SUBGR_NAME,
                item_list_name: product.G_SUBGR_NAME,
                item_list_id: product.G_SUBGR_EN_NAME,
                index: product.G_CODE,
            }]
        }
    )
}


export const addToCartProductDataLayer = (product) => {
    DataLayerMain(
        'add_to_cart', 
        {
            items: [{
                item_name: product.G_NAME,
                item_id: product.G_CODE,
                item_brand: product.G_BR_NAME,
                item_category: product.G_GR_NAME,
                item_category2: product.G_SUBGR_NAME,
                item_list_name: product.G_SUBGR_NAME,
                item_list_id: product.G_SUBGR_EN_NAME,
                index: product.G_CODE,

                price: product.SH_G_PRICE,
                item_variant: product.G_COL_NAME,
                quantity: product.quantity
            }]
        }
    )
}


export const delFromCartProductDataLayer = (product) => {
    DataLayerMain(
        'remove_from_cart', 
        {
            items: [{
                item_name: product.G_NAME,
                item_id: product.G_CODE,
                item_brand: product.G_BR_NAME,
                item_category: product.G_GR_NAME,
                item_category2: product.G_SUBGR_NAME,
                item_list_name: product.G_SUBGR_NAME,
                item_list_id: product.G_SUBGR_EN_NAME,
                index: product.G_CODE,

                price: product.SH_G_PRICE,
                item_variant: product.G_COL_NAME,
                quantity: product.quantity
            }]
        }
    )
}


export const viewCartProductDataLayer = (products = []) => {
    let itemsTemp = products.map((product) => {
        return {
            item_name: product.G_NAME,
            item_id: product.G_CODE,
            item_brand: product.G_BR_NAME,
            item_category: product.G_GR_NAME,
            item_category2: product.G_SUBGR_NAME,
            item_list_name: product.G_SUBGR_NAME,
            item_list_id: product.G_SUBGR_EN_NAME,
            index: product.G_CODE,

            price: product.SH_G_PRICE,
            item_variant: product.G_COL_NAME,
            quantity: product.quantity
        }
    })
    DataLayerMain(
        'view_cart', 
        {
            items: itemsTemp
        }
    )
}

export const biganCheckoutProductDataLayer = (products = []) => {
    let itemsTemp = products.map((product) => {
        return {
            item_name: product.G_NAME,
            item_id: product.G_CODE,
            item_brand: product.G_BR_NAME,
            item_category: product.G_GR_NAME,
            item_category2: product.G_SUBGR_NAME,
            item_list_name: product.G_SUBGR_NAME,
            item_list_id: product.G_SUBGR_EN_NAME,
            index: product.G_CODE,

            price: product.SH_G_PRICE,
            item_variant: product.G_COL_NAME,
            quantity: product.quantity
        }
    })
    DataLayerMain(
        'begin_checkout', 
        {
            items: itemsTemp
        }
    )
}


export const addShippingProductDataLayer = (products = []) => {
    let itemsTemp = products.map((product) => {
        return {
            item_name: product.G_NAME,
            item_id: product.G_CODE,
            item_brand: product.G_BR_NAME,
            item_category: product.G_GR_NAME,
            item_category2: product.G_SUBGR_NAME,
            item_list_name: product.G_SUBGR_NAME,
            item_list_id: product.G_SUBGR_EN_NAME,
            index: product.G_CODE,

            price: product.SH_G_PRICE,
            item_variant: product.G_COL_NAME,
            quantity: product.quantity
        }
    })
    DataLayerMain(
        'add_shipping_info', 
        {
            shipping_tier: 'Normal',
            items: itemsTemp
        }
    )
}

export const paymentProductDataLayer = (products = []) => {
    let itemsTemp = products.map((product) => {
        return {
            item_name: product.G_NAME,
            item_id: product.G_CODE,
            item_brand: product.G_BR_NAME,
            item_category: product.G_GR_NAME,
            item_category2: product.G_SUBGR_NAME,
            item_list_name: product.G_SUBGR_NAME,
            item_list_id: product.G_SUBGR_EN_NAME,
            index: product.G_CODE,

            price: product.SH_G_PRICE,
            item_variant: product.G_COL_NAME,
            quantity: product.quantity
        }
    })
    DataLayerMain(
        'add_payment_info', 
        {
            payment_type: 'COD',
            items: itemsTemp
        }
    )
}

export const paymentEndProductDataLayer = (summery, products = []) => {
    let itemsTemp = products.map((product) => {
        return {
            item_name: product.G_NAME,
            item_id: product.G_CODE,
            item_brand: product.G_BR_NAME,
            item_category: product.G_GR_NAME,
            item_category2: product.G_SUBGR_NAME,
            item_list_name: product.G_SUBGR_NAME,
            item_list_id: product.G_SUBGR_EN_NAME,
            index: product.G_CODE,

            price: product.price,
            item_variant: product.G_COL_NAME,
            quantity: product.quantity
        }
    })
    DataLayerMain(
        'purchase', 
        {
            currency: 'IRL',
            value: summery.TOTAL,
            tax: summery.SUM_BASK_DET_TAX,
            shipping: summery.SHIPPING_COST,
            transaction_id: "lil-" + summery.INV_NO,
            items: itemsTemp
        }
    )
}

export const directEventDataLayer = (eventName = "") => {
    DataLayerMain(
        eventName, {}
    )
}